import { useLookbookProductItemContext } from '@app/components/products/context/LookbookProductItemContext';
import { ProductCardAttributes } from '@app/components/products/ProductCard/ProductCardAttributes';
import { Tooltip } from '@app/components/various/Tooltip';
import { useIsOverflowing } from '@app/utils/hooks/useIsOverflowing';
import { useOffsetWidth } from '@app/utils/hooks/useOffsetWidth';
import { isDefined } from '@app/utils/is';
import React from 'react';
import { Link } from 'react-router-dom';

import { LookbookGalleryDots } from './LookbookGallery/LookbookGalleryDots';
import { LookbookGallery } from './LookbookGallery';

const COMPACT_CARD_WIDTH = 240;
const BADGES_PADDING = 24;

export const ProductMediumCard = () => {
  const { containerRef, activeSlideVariant, productPathName } = useLookbookProductItemContext();
  const nameRef = React.useRef<HTMLHeadingElement>(null);
  const width = useOffsetWidth(containerRef);
  const isNameOverflowing = useIsOverflowing(nameRef);
  const isCompact = width < COMPACT_CARD_WIDTH;

  return (
    <div ref={containerRef} className="flex flex-col overflow-hidden rounded-regular bg-white pb-3 transition-shadow md:hover:shadow-2">
      <LookbookGallery isCompact={isCompact} parentWidth={width} />
      {isDefined(activeSlideVariant) && (
        <div className="relative flex flex-1 flex-col bg-white px-3 pt-3">
          <div className="absolute -top-3 left-1/2 max-w-full -translate-x-1/2 rounded-large bg-white">
            <LookbookGalleryDots parentWidth={width - BADGES_PADDING} />
          </div>
          <Link className="mb-2 rounded-small focus-visible:focus-outline" to={productPathName}>
            <Tooltip overlayClassName="max-w-52" content={isNameOverflowing && activeSlideVariant.name} disableOnTouchScreen>
              <div>
                <h3 ref={nameRef} className="line-clamp-3 heading-3">
                  {activeSlideVariant.name}
                </h3>
              </div>
            </Tooltip>
          </Link>
          <ProductCardAttributes productsGridSize="medium" variant={activeSlideVariant} shouldShowRrp />
        </div>
      )}
    </div>
  );
};
